<template>
    <div
        ref="convstooltip"
        class="con-vs-tooltip"
        @mouseenter="mouseenterx"
        @mouseleave="mouseleavex"
        @mouseup="destroy"
    >
        <transition name="tooltip-fade">
            <div
                v-show="active"
                ref="vstooltip"
                :class="[`vs-tooltip-${positionx || position}`,`vs-tooltip-${color}`, {'after-none': noneAfter}]"
                :style="style"
                class="vs-tooltip"
            >
                <h4 v-if="title">
                    {{ title }}
                </h4>
                {{ text }}
            </div>
        </transition>
        <slot />
    </div>
</template>
<script>
import _color from '@/utils/color';
import utils from '@/utils/dom';

export default {
    name:  'VxTooltip',
    props: {
        color: {
            default: null,
            type:    String,
        },
        delay: {
            default: '0s',
            type:    [Number, String],
        },
        offset: {
            default: 0,
            type:    Number,
        },
        position: {
            default: 'top',
            type:    String,
        },
        text: {
            default: null,
            type:    [String, Number],
        },
        title: {
            default: null,
            type:    [String, Number],
        },
    },
    data: () => ({
        cords:     {},
        active:    false,
        widthx:    'auto',
        positionx: null,
        noneAfter: false,
    }),
    computed: {
        style() {
            return {
                background:      _color.getColor(this.color, 1),
                left:            this.cords.left,
                top:             this.cords.top,
                transitionDelay: this.active ? this.delay : '0s',
                width:           this.widthx,
            };
        },
    },
    methods: {
        changePosition(elxEvent, tooltip) {
            this.noneAfter = false;
            this.positionx = null;
            const elx = elxEvent.closest('.con-vs-tooltip');
            const scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
            let topx = elx.getBoundingClientRect().top + scrollTopx - tooltip.clientHeight - 4 - this.offset;
            let leftx = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 + elx.clientWidth / 2;
            const widthx = elx.clientWidth;

            if (this.position === 'bottom') {
                topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4 + this.offset;
            } else if (this.position === 'left') {
                leftx = elx.getBoundingClientRect().left - tooltip.clientWidth - 4 - this.offset;
                topx = elx.getBoundingClientRect()
                    .top + scrollTopx + (elx.clientHeight / 2) - (tooltip.clientHeight / 2);

                if (Math.sign(leftx) === -1) {
                    leftx = elx.getBoundingClientRect().left;
                    topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4;
                    this.positionx = 'bottom';
                    this.noneAfter = true;
                }
            } else if (this.position === 'right') {
                leftx = elx.getBoundingClientRect().left + elx.clientWidth + 4 + this.offset;
                topx = elx.getBoundingClientRect()
                    .top + scrollTopx + (elx.clientHeight / 2) - (tooltip.clientHeight / 2);

                if (window.innerWidth - (leftx + tooltip.clientWidth) <= 20) {
                    leftx = elx.getBoundingClientRect().left - tooltip.clientWidth / 2 - 10;
                    topx = elx.getBoundingClientRect().top + scrollTopx + elx.clientHeight + 4 + this.offset;
                    this.positionx = 'bottom';
                    this.noneAfter = true;
                }
            }

            this.cords = {
                left:  `${leftx}px`,
                top:   `${topx}px`,
                width: `${widthx}px`,
            };
        },
        destroy() {
            this.active = false;
            this.$nextTick(() => {
                if (this.active) {
                    utils.removeBody(this.$refs.vstooltip);
                }
            });
        },
        mouseenterx() {
            this.active = true;
            this.$nextTick(() => {
                utils.insertBody(this.$refs.vstooltip);
                this.changePosition(this.$refs.convstooltip, this.$refs.vstooltip);
            });
        },
        mouseleavex() {
            this.active = false;
        },
    },
};
</script>
